import statesCities from './states';
import { showLoading, stopLoading } from '../components/loading';

const cepFn = () => {
  const selectState = $('#state');
  const selectCity = $('#city');
  const cepErrorContainer = $('.checkout-shipping-cep');
  const cepErrorContent = $('.checkout-shipping-cep__title');
  const checkoutForm = $('.checkout-shipping__form');
  const checkoutBtn = $('.checkout-address__btn-change');
  const checkoutBtnSubmit = $('.catalog-data__button--submit');
  let states = '<option value=""></option>';
  let cities;

  cepErrorContent.hide();

  $.each(statesCities, (key, item) => {
    states += `<option value='${item.initial}'>${item.initial}</option>`;
  });

  selectState.html(states);
  selectCity.html(cities);

  selectState.change(() => {
    let currentState;
    const selectedState = $('#state option:selected');

    selectedState.each(() => {
      currentState = selectedState.val();
    });
    cities = '<option value=""></option>';

    $.each(statesCities, (key, item) => {
      if (item.initial === currentState) {
        $.each(item.cities, (keyCity, itemCity) => {
          cities += `<option value='${itemCity}'>${itemCity}</option>`;
        });
      }
    });

    selectCity.html(cities);
  }).change();

  const clearAddress = () => {
    $('#address').val('');
    $('#city').val('');
    $('#state').val('');
  };

  const cepFound = () => {
    cepErrorContent.hide();
    cepErrorContent.text('');
    checkoutForm.show();
    checkoutBtn.show();
    checkoutBtn.removeAttr('disabled');
    checkoutBtnSubmit.removeAttr('disabled');
  };

  const cepNotFound = (message) => {
    cepErrorContent.show();
    cepErrorContent.text(message);
    checkoutForm.hide();
    checkoutBtn.hide();
    checkoutBtn.attr('disabled', 'true');
    checkoutBtnSubmit.attr('disabled', 'true');
  };

  $('#cep').blur(function () {
    const cep = $(this).val().replace(/\D/g, '');

    if (cep !== '') {
      const cepValidate = /^[0-9]{8}$/;

      if (cepValidate.test(cep)) {
        const messageLoading = 'Carregando...';

        $('#city').val(messageLoading).attr('disabled', 'disabled');
        $('#state').val(messageLoading).attr('disabled', 'disabled');

        showLoading();

        // Consulta o webservice viacep.com.br/
        $.getJSON(`//viacep.com.br/ws/${cep}/json/?callback=?`, (dados) => {
          if (!('erro' in dados)) {
            if (dados.logradouro !== '') {
              $('#address').val(dados.logradouro).removeAttr('disabled');
              $('#address').trigger('change').trigger('focusout');
            }
            $('#state').val(dados.uf).removeAttr('disabled');
            $('#state').trigger('change').trigger('focusout');
            $('#city').val(dados.localidade).removeAttr('disabled');
            $('#city').trigger('change').trigger('focusout');

            cepFound();
          } else {
            clearAddress();

            if (cepErrorContainer.hasClass('checkout-shipping-cep--hide')) {
              cepNotFound('CEP não encontrado');
            } else {
              $('#address').val('CEP não encontrado.');
            }
          }
        })
          .done(() => {
            setTimeout(() => {
              stopLoading();
            }, 300);
          });
      } else {
        clearAddress();
        cepNotFound('Formato de CEP inválido.');
        $('#address').val('Formato de CEP inválido.');
      }
    } else {
      clearAddress();
    }
  }).blur();
};

export default cepFn;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/cepSearch.js